import React, { useState } from "react";
import { useEffect } from "react";
import "./base-panel.scss";

const BasePanel = ({ _class = null, title, text, onMessageClose, loc }) => {
    const [timer, setTimer] = useState();
    useEffect(() => {
        setTimer(setTimeout(() => onMessageClose(), 20000));

        return () => {
            clearInterval(timer);
        };
    }, []); // eslint-disable-line

    return (
        <div className={`base-panel ${_class}`} role="alert">
            <strong>{title}</strong>
            {text}
            <button type="button" className="close" aria-label={loc("buttons.close")} onClick={onMessageClose}>
                <span aria-hidden="true">×</span>
            </button>
        </div>
    );
};

export default BasePanel;
